{
  "title": "Let's make a ✨dazzling✨ schedule!",
  "placeholder": "Describe the schedule you'd like to make.",
  "submit": "Create",
  "cancel": "Cancel",
  "try_prompt": "Try it",
  "sample_title": "🪄 Need some inspiration? Try one of these",
  "entry_limit": "We'll create up to 50 events to start, you can always add more later!",
  "enter_hint": "Press <1>shift</1> + <3>enter</3> to submit or <6>enter</6> to add a new line",
  "submitted": "Got it, coming right up!",
  "loading": "Hold, please!",
  "almost_there": "Almost there…",
  "welcome_title": "Welcome to your schedule!",
  "welcome_description": "🎉 Hooray! Your awesome new schedule awaits! Edit, add, and make it a blast! 🌟🚀",
  "confirm": "Got it",
  "error_message": "Oops, our AI cogs hiccuped! Adjust your prompt and let's retry."
}
